import isClient from 'commons/isClient';

function getBreakpoint() {
  if (isClient()) {
    return window
      .getComputedStyle(document.body, ':before')
      .content.replace(/"/g, '');
  }
  return '';
}

export default getBreakpoint;
